var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"config":_vm.config,"fields":_vm.fields,"modals":_vm.modals,"header":_vm.header,"methods":_vm.methods},scopedSlots:_vm._u([{key:"IMAGE",fn:function(ref){
var row = ref.row;
return [(row && row.img_link)?_c('img',{staticStyle:{"height":"60px"},attrs:{"src":row.img_link},on:{"click":function($event){return _vm.preview(row.img_link)}}}):_vm._e()]}},{key:"PREVIEW",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
return [(visible)?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":params.src}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }